import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { StandaloneAuth } from '@leagueplatform/auth-standalone';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import { logout } from 'common/logout';

export const AuthViewLogout = () => {
  useEffect(() => {
    logout();
  }, []);

  return <LoadingIndicator />;
};

export const AuthViewLogin = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const forceLogin = searchParams.get('prompt') === 'login';
    StandaloneAuth.client.loginWithRedirect(
      forceLogin ? { prompt: 'login' } : {},
    );
  }, [searchParams]);

  return <LoadingIndicator />;
};
